import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "width", "height", "fill"];
import React from 'react';
import PropTypes from 'prop-types';

var Full = function Full() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M12 18.472l-5.382 2.83a.75.75 0 0 1-1.088-.79l1.028-5.994-4.354-4.244a.75.75 0 0 1 .415-1.28l6.017-.873 2.691-5.453a.75.75 0 0 1 1.346 0l2.69 5.453 6.018.874a.75.75 0 0 1 .415 1.28l-4.354 4.243 1.028 5.993a.75.75 0 0 1-1.088.79L12 18.473z"
  });
};

var Empty = function Empty() {
  return /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M12 18.472l-5.382 2.83a.75.75 0 0 1-1.088-.79l1.028-5.994-4.354-4.244a.75.75 0 0 1 .415-1.28l6.017-.873 2.691-5.453a.75.75 0 0 1 1.346 0l2.69 5.453 6.018.874a.75.75 0 0 1 .415 1.28l-4.354 4.243 1.028 5.993a.75.75 0 0 1-1.088.79L12 18.473z"
  });
};

var Half = function Half() {
  return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M12 18.472l-5.382 2.83a.75.75 0 0 1-1.088-.79l1.028-5.994-4.354-4.244a.75.75 0 0 1 .415-1.28l6.017-.873 2.691-5.453a.75.75 0 0 1 1.346 0l2.69 5.453 6.018.874a.75.75 0 0 1 .415 1.28l-4.354 4.243 1.028 5.993a.75.75 0 0 1-1.088.79L12 18.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.472l-5.382 2.83a.75.75 0 0 1-1.088-.79l1.028-5.994-4.354-4.244a.75.75 0 0 1 .415-1.28l6.017-.873 2.691-5.453A.741.741 0 0 1 12 2.25v16.222z"
  }));
};

var StarIcon = function StarIcon(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'full' : _ref$type,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#EFC71D' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), type === 'full' && /*#__PURE__*/React.createElement(Full, null), type === 'half' && /*#__PURE__*/React.createElement(Half, null), type === 'empty' && /*#__PURE__*/React.createElement(Empty, null));
};

StarIcon.displayName = 'StarIcon';
Half.displayName = 'Half';
Empty.displayName = 'Empty';
Full.displayName = 'Full';
StarIcon.propTypes = {
  type: PropTypes.oneOf(['full', 'half', 'empty'])
};
export default StarIcon;